// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"506":"a77d7ad6","725":"22239ce2"}[chunkId] + ".chunk.css";
};